// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".authorize .title[data-v-8d846c24] {\n  padding-left: 10px;\n  border-left: 3px solid var(--prev-color-primary);\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #303133;\n}\n.selWidth[data-v-8d846c24] {\n  width: 600px;\n}", ""]);
// Exports
module.exports = exports;
